import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {PostalCodeSelectorDialogComponent} from '../postal-code-selector-dialog/postal-code-selector-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-zip-code-form',
  templateUrl: './zip-code-form.component.html',
  styleUrls: ['./zip-code-form.component.scss']
})
export class ZipCodeFormComponent implements OnInit {
  zipForm = this.formBuilder.group({
    zipCode: ['', [Validators.required]],
  });
  constructor(private formBuilder: FormBuilder, private router: Router, private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  async onSubmit(): Promise<any> {
    const { zipCode } = this.zipForm.value;
    await this.router.navigateByUrl(`/choose-product?zipCode=${zipCode}`);
    this.zipForm.reset();
  }

  selectPostalCode(): void {
    const dialogRef = this.dialog.open(PostalCodeSelectorDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
